import React, {Component} from 'react'
import {Helmet} from 'react-helmet'
import MetaTags from 'react-meta-tags'
import {FeatureImage} from '../components/FeatureImage/index'
import {Loader} from '../components/Loader'
import OrderEvent from '../components/OrderEvent/index'
import MobileOrderEvent from '../components/OrderEvent/mobile'
import {getEventBySlug} from "../api/async/events";
import {EventDetail} from "../components/EventDetail";

class Event extends Component {
    state = {
        addons: [],
    }

    componentDidMount = () => {
        const slug = this.props.match.params.slug
        getEventBySlug(slug).then(res => this.setState({event: res.data}))
    }


    render() {
        return (
            <React.Fragment>
                {this.state.event ? (
                    <React.Fragment>
                        <Helmet>
                            <meta charSet="utf-8"/>
                            <title>{`Run24Hrs - ${this.state.event.title}`}</title>
                        </Helmet>
                        <MetaTags>
                            <meta property="og:title" content={this.state.event.title}/>
                            <meta
                                property="og:image"
                                content={this.state.event.feature_image}
                            />
                        </MetaTags>
                        <MobileOrderEvent
                            event={this.state.event}
                        />
                        <div style={{marginBottom: 10}}>
                            <FeatureImage imgSrc={this.state.event.feature_image}/>
                        </div>
                        <div className="ui stackable grid">
                            <div className="eleven wide column">
                                <EventDetail
                                    event={this.state.event}
                                />
                            </div>
                            <div className="five wide column">
                                <OrderEvent
                                    event={this.state.event}
                                />
                            </div>
                        </div>
                    </React.Fragment>
                ) : (
                    <Loader/>
                )}
            </React.Fragment>
        )
    }
}

export default Event



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Event.js